let _ = t => t,
  _t;
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { FilterBar } from 'foundations-components/transitional/components/FilterBar';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Select } from 'foundations-components/transitional/components/Select';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { supportedPublicLanguages } from 'academy-common-lib/constants/academySupportedLanguages';
import LanguageNames from 'ui-addon-i18n/constants/LanguageNames';
import { useSearchParams } from '../../../utils/searchParams';
import styled from 'academy-common-lib/utils/Styling';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CERTIFICATIONS_ONLY_OPTION, PublicCatalogFilters, FilterNames } from '../publicCatalogConstants';
import AppliedFilters from './PublicCatalogAppliedFilters';
import I18n from 'I18n';
import { useAddFilter, useRemoveFilter, useClearFilter, useToggleFilter, useSetFilter } from '../publicCatalogFiltersHooks';
import { ThemedDropdown, ThemedLinkMixin, ThemedToggle } from '../../../components/ThemedComponents';
import styledWithTheme from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PipeDivider = styledWithTheme.span(_t || (_t = _`
  display: inline-block;
  border-right: ${0} solid
    ${0};
  margin: 0 ${0} 0
    ${0};
  height: 20px;
`), ({
  theme
}) => theme.borderWidth['200'], ({
  theme
}) => theme.color['do-not-use-battleship'], ({
  theme
}) => theme.space['250'], ({
  theme
}) => theme.space['500']);
const StyledSpan = styled.span.withConfig({
  displayName: "PublicCatalogFilters__StyledSpan",
  componentId: "sc-16b7c91-0"
})(() => ({
  '*': Object.assign({}, ThemedLinkMixin())
}));
const CertificationsOnlyToggle = () => {
  var _searchParams$awardTy;
  const [searchParams] = useSearchParams();
  const toggleFilter = useToggleFilter();
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(FormLabel, {
      htmlFor: "certifications-only-toggle",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.catalogPage.filters.awardType.options.ONLY_SHOW_CERTIFICATE_COURSES"
      })
    }), /*#__PURE__*/_jsx(ThemedToggle, {
      checked: (_searchParams$awardTy = searchParams.awardType) === null || _searchParams$awardTy === void 0 ? void 0 : _searchParams$awardTy.includes(CERTIFICATIONS_ONLY_OPTION),
      id: "certifications-only-toggle",
      onChange: () => toggleFilter(FilterNames.AWARD_TYPE, CERTIFICATIONS_ONLY_OPTION),
      size: "small"
    })]
  });
};
const CheckboxFilter = ({
  filterName,
  displayText,
  options
}) => {
  const [searchParams] = useSearchParams();
  const removeFilter = useRemoveFilter();
  const addFilter = useAddFilter();
  const clearFilter = useClearFilter();
  const getFilterChangeHandler = (isAllOption, currentOption, isCurrentOptionSelected) => () => {
    if (isAllOption) {
      clearFilter(filterName);
      return;
    }
    if (isCurrentOptionSelected) {
      removeFilter(filterName, currentOption);
      return;
    }
    addFilter(filterName, currentOption);
  };
  return /*#__PURE__*/_jsx("span", {
    children: /*#__PURE__*/_jsx(ThemedDropdown, {
      buttonText: displayText,
      buttonUse: "transparent",
      children: /*#__PURE__*/_jsx(ToggleGroup, {
        name: filterName,
        children: options.map(option => {
          const selectedOptions = searchParams[filterName] || [];
          const isAllOption = option === 'ALL';
          const isNoOptionSelected = selectedOptions.length === 0;
          const isCurrentOptionSelected = selectedOptions.includes(option);
          return /*#__PURE__*/_jsx(Checkbox, {
            checked: isAllOption ? isNoOptionSelected : isCurrentOptionSelected,
            onChange: getFilterChangeHandler(isAllOption, option, isCurrentOptionSelected),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `academyPublic.catalogPage.filters.${filterName}.options.${option}`
            })
          }, option);
        })
      })
    })
  }, filterName);
};
const LanguageFilter = () => {
  const setFilter = useSetFilter();
  const languageOptions = supportedPublicLanguages.map(language => {
    return {
      text: LanguageNames[language],
      value: language
    };
  });
  return /*#__PURE__*/_jsx(StyledSpan, {
    children: /*#__PURE__*/_jsx(Select, {
      buttonUse: "transparent",
      error: false,
      onChange: ({
        target: {
          value: languageValue
        }
      }) => {
        setFilter(FilterNames.LANGUAGE, languageValue);
      },
      options: languageOptions,
      value: I18n.text('academyPublic.catalogPage.filters.language.displayText')
    })
  });
};
const PublicCatalogFiltersComponent = () => {
  return /*#__PURE__*/_jsxs(View, {
    as: "div",
    marginBlockEnd: "1000",
    children: [/*#__PURE__*/_jsx(FilterBar, {
      middleSlot: /*#__PURE__*/_jsxs(TFlex, {
        align: "center",
        wrap: "wrap",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "strong",
          marginInlineEnd: "800",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.catalogPage.filters.filterBy"
          })
        }), /*#__PURE__*/_jsx(CertificationsOnlyToggle, {}), /*#__PURE__*/_jsx(PipeDivider, {}), [FilterNames.LEVEL, FilterNames.DURATION, FilterNames.CONTENT_TYPE].map(filterName => /*#__PURE__*/_jsx(CheckboxFilter, {
          displayText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `academyPublic.catalogPage.filters.${filterName}.displayText`
          }),
          filterName: filterName,
          options: PublicCatalogFilters[filterName]
        }, filterName)), /*#__PURE__*/_jsx(LanguageFilter, {})]
      })
    }), /*#__PURE__*/_jsx(AppliedFilters, {})]
  });
};
export default PublicCatalogFiltersComponent;